/* =====================================================================
   COLDFRAME — 장바구니 (cf-cart.js)
   카페24 order/basket.html 의 동작을 쇼피파이 장바구니 API 로 옮긴 파일
   - 수량 +/- · 직접 입력 : /cart/change.js
   - 상품 삭제(X) · 선택상품삭제 : /cart/change.js · /cart/update.js
   - 전체상품선택 : 체크박스 전체 선택/해제
   - 옵션변경 창 : [추가] 선택한 옵션을 새로 담기 / [변경] 선택한 옵션으로 바꾸기
   - 위시리스트에 담기 : Swish(위시리스트 앱) 사용
   변경 후에는 장바구니 영역만 다시 불러옵니다 (선택 상태 유지).
   ===================================================================== */
(function () {
  'use strict';

  var ROOT = '[data-cf-cart]';
  var busy = false;

  function getRoot(el) {
    return el && el.closest ? el.closest(ROOT) : document.querySelector(ROOT);
  }

  function jsonUrl(url) {
    return url.replace(/\/$/, '') + '.js';
  }

  function request(url, body) {
    return fetch(jsonUrl(url), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = {};
        try { data = text ? JSON.parse(text) : {}; } catch (e) { data = {}; }
        if (!res.ok || data.status === 422 || data.status === 'bad_request') {
          var error = new Error(data.description || data.message || res.statusText || 'Error');
          error.data = data;
          throw error;
        }
        return data;
      });
    });
  }

  function checkedKeys(root) {
    return Array.prototype.map.call(root.querySelectorAll('[data-cf-check]:checked'), function (input) {
      var line = input.closest('[data-cf-line]');
      return line ? line.getAttribute('data-key') : null;
    }).filter(Boolean);
  }

  /* 장바구니 영역 다시 불러오기 (쇼피파이 Section Rendering API) */
  function refresh(root, keepChecked) {
    var sectionId = root.getAttribute('data-section-id');
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error(res.statusText);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(ROOT);
        if (!fresh) throw new Error('cart section not found');
        root.parentNode.replaceChild(fresh, root);
        (keepChecked || []).forEach(function (key) {
          var line = fresh.querySelector('[data-cf-line][data-key="' + cssEscape(key) + '"]');
          var check = line && line.querySelector('[data-cf-check]');
          if (check) check.checked = true;
        });
        init(fresh);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function cssEscape(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/["\\]/g, '\\$&');
  }

  function run(root, task) {
    if (busy) return Promise.resolve();
    busy = true;
    var keep = checkedKeys(root);
    root.classList.add('is-loading');
    return task()
      .catch(function (error) {
        if (error && error.message) window.alert(error.message);
      })
      .then(function () {
        return refresh(root, keep);
      })
      .then(function () {
        busy = false;
      }, function () {
        busy = false;
      });
  }

  /* ------------------------------------------------------------------
     수량 변경
     ------------------------------------------------------------------ */
  function changeQuantity(line, quantity) {
    var root = getRoot(line);
    var key = line.getAttribute('data-key');
    var current = parseInt(line.getAttribute('data-quantity'), 10) || 1;
    var input = line.querySelector('[data-cf-qty]');
    if (!(quantity >= 1)) {
      if (input) input.value = current;
      return;
    }
    if (quantity === current) {
      if (input) input.value = current;
      return;
    }
    if (input) input.value = quantity;
    run(root, function () {
      return request(root.getAttribute('data-cart-change-url'), { id: key, quantity: quantity });
    });
  }

  function removeLines(root, keys) {
    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });
    return run(root, function () {
      return request(root.getAttribute('data-cart-update-url'), { updates: updates });
    });
  }

  /* ------------------------------------------------------------------
     옵션 변경 창
     ------------------------------------------------------------------ */
  function closeLayer(root) {
    var layer = root.querySelector('#ec-basketOptionModifyLayer');
    if (layer) layer.parentNode.removeChild(layer);
    document.removeEventListener('keydown', onLayerKeydown);
  }

  function onLayerKeydown(event) {
    if (event.key === 'Escape') closeLayer(getRoot(null));
  }

  function openLayer(line) {
    var root = getRoot(line);
    var dataEl = line.querySelector('[data-cf-line-product]');
    var template = root.querySelector('template[data-cf-option-layer]');
    if (!dataEl || !template) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    closeLayer(root);
    var fragment = template.content.cloneNode(true);
    var layer = fragment.querySelector('#ec-basketOptionModifyLayer');
    var optionStr = line.querySelector('.optionStr');
    layer.querySelector('[data-cf-layer-title]').textContent = data.title;
    layer.querySelector('[data-cf-layer-current]').textContent = optionStr ? optionStr.textContent.trim() : '';

    var list = layer.querySelector('[data-cf-layer-options]');
    var placeholder = root.getAttribute('data-text-option-placeholder') || '';
    data.options.forEach(function (name, index) {
      var values = [];
      data.variants.forEach(function (variant) {
        var value = variant.options[index];
        if (values.indexOf(value) === -1) values.push(value);
      });
      var li = document.createElement('li');
      li.className = 'ec-basketOptionModifyLayer-options';
      var desc = document.createElement('span');
      desc.className = 'optionDesc';
      desc.textContent = name;
      var select = document.createElement('select');
      select.setAttribute('data-cf-layer-option', String(index));
      select.setAttribute('aria-label', name);
      select.appendChild(new Option('- ' + placeholder + ' -', ''));
      var dash = new Option('-------------------', '');
      dash.disabled = true;
      select.appendChild(dash);
      var group = document.createElement('optgroup');
      group.label = name;
      values.forEach(function (value) {
        var option = new Option((data.labels && data.labels[value]) || value, value); // 반지 US 사이즈 표시 (2026-10-20)
        if (data.current && data.current[index] === value) option.selected = true;
        group.appendChild(option);
      });
      select.appendChild(group);
      li.appendChild(desc);
      li.appendChild(document.createTextNode(' '));
      li.appendChild(select);
      list.appendChild(li);
    });

    layer.querySelector('[data-cf-layer-close]').addEventListener('click', function (event) {
      event.preventDefault();
      closeLayer(root);
    });
    layer.querySelector('[data-cf-layer-add]').addEventListener('click', function (event) {
      event.preventDefault();
      submitLayer(root, line, data, layer, 'add');
    });
    layer.querySelector('[data-cf-layer-modify]').addEventListener('click', function (event) {
      event.preventDefault();
      submitLayer(root, line, data, layer, 'modify');
    });

    root.querySelector('.xans-order-basketpackage').insertAdjacentElement('afterend', layer);
    document.addEventListener('keydown', onLayerKeydown);
  }

  function submitLayer(root, line, data, layer, mode) {
    var selected = Array.prototype.map.call(layer.querySelectorAll('[data-cf-layer-option]'), function (select) {
      return select.value;
    });
    if (selected.some(function (value) { return !value; })) {
      window.alert(root.getAttribute('data-text-select-option'));
      return;
    }
    var variant = data.variants.filter(function (v) {
      return v.options.every(function (value, i) { return value === selected[i]; });
    })[0];
    if (!variant || !variant.available) {
      window.alert(root.getAttribute('data-text-option-unavailable'));
      return;
    }
    var key = line.getAttribute('data-key');
    var currentId = parseInt(line.getAttribute('data-variant-id'), 10);
    var quantity = parseInt(line.getAttribute('data-quantity'), 10) || 1;
    var properties = data.properties && typeof data.properties === 'object' ? data.properties : {};

    if (mode === 'modify' && variant.id === currentId) {
      closeLayer(root);
      return;
    }
    closeLayer(root);
    run(root, function () {
      var addUrl = root.getAttribute('data-cart-add-url');
      if (mode === 'add') {
        return request(addUrl, { items: [{ id: variant.id, quantity: 1 }] });
      }
      // [변경] 새 옵션을 먼저 담고(실패하면 기존 상품 유지) 기존 상품을 뺍니다.
      return request(addUrl, { items: [{ id: variant.id, quantity: quantity, properties: properties }] }).then(function () {
        return request(root.getAttribute('data-cart-change-url'), { id: key, quantity: 0 });
      });
    });
  }

  /* ------------------------------------------------------------------
     위시리스트 (Swish 앱이 있을 때만 버튼 표시)
     ------------------------------------------------------------------ */
  function wishlistApi() {
    var api = window.WishlistKing;
    return api && typeof api.saveForLater === 'function' ? api : null;
  }

  function showWishButtons(root) {
    var tries = 0;
    (function check() {
      if (!document.body.contains(root)) return;
      if (wishlistApi()) {
        root.querySelectorAll('[data-cf-wish]').forEach(function (button) {
          button.hidden = false;
        });
        return;
      }
      if (++tries < 40) setTimeout(check, 250);
    })();
  }

  function addToWishlist(line) {
    var root = getRoot(line);
    var api = wishlistApi();
    if (!api) return;
    api.saveForLater({
      productHandle: line.getAttribute('data-product-handle'),
      variantId: parseInt(line.getAttribute('data-variant-id'), 10)
    }).then(function (result) {
      if (result) window.alert(root.getAttribute('data-text-wish-added'));
    }).catch(function (error) {
      if (window.console) console.error(error);
    });
  }

  /* ------------------------------------------------------------------
     이벤트 (문서 전체에서 위임 — 다시 불러온 뒤에도 동작)
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;
    var root = getRoot(target);
    if (!root || target.closest('#ec-basketOptionModifyLayer')) return;
    var line = target.closest('[data-cf-line]');
    var el;

    if ((el = target.closest('[data-cf-qty-up], [data-cf-qty-down]')) && line) {
      event.preventDefault();
      var input = line.querySelector('[data-cf-qty]');
      var value = parseInt(input && input.value, 10) || parseInt(line.getAttribute('data-quantity'), 10) || 1;
      changeQuantity(line, el.hasAttribute('data-cf-qty-up') ? value + 1 : value - 1);
    } else if ((el = target.closest('[data-cf-qty-apply]')) && line) {
      event.preventDefault();
      changeQuantity(line, parseInt(line.querySelector('[data-cf-qty]').value, 10));
    } else if ((el = target.closest('[data-cf-remove]')) && line) {
      event.preventDefault();
      if (window.confirm(root.getAttribute('data-text-delete-item-confirm'))) {
        removeLines(root, [line.getAttribute('data-key')]);
      }
    } else if ((el = target.closest('[data-cf-option-change]')) && line) {
      event.preventDefault();
      openLayer(line);
    } else if ((el = target.closest('[data-cf-wish]')) && line) {
      event.preventDefault();
      addToWishlist(line);
    } else if ((el = target.closest('[data-cf-select-all]'))) {
      event.preventDefault();
      var checks = root.querySelectorAll('[data-cf-check]');
      var allChecked = checks.length > 0 && Array.prototype.every.call(checks, function (c) { return c.checked; });
      checks.forEach(function (c) { c.checked = !allChecked; });
      el.setAttribute('data-status', allChecked ? 'off' : 'on');
    } else if ((el = target.closest('[data-cf-delete-selected]'))) {
      event.preventDefault();
      var keys = checkedKeys(root);
      if (!keys.length) {
        window.alert(root.getAttribute('data-text-select-item'));
      } else if (window.confirm(root.getAttribute('data-text-delete-confirm'))) {
        removeLines(root, keys);
      }
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target.matches) return;
    if (target.matches('[data-cf-cart] [data-cf-qty]')) {
      var line = target.closest('[data-cf-line]');
      changeQuantity(line, parseInt(target.value, 10));
    } else if (target.matches('[data-cf-cart] [data-cf-note]')) {
      var root = getRoot(target);
      request(root.getAttribute('data-cart-update-url'), { note: target.value }).catch(function () {});
    }
  });

  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (event.key === 'Enter' && target.matches && target.matches('[data-cf-cart] [data-cf-qty]')) {
      // 엔터 키로 결제(폼 전송)가 되지 않도록 수량만 변경
      event.preventDefault();
      target.blur();
    }
  });

  function init(root) {
    if (!root) return;
    showWishButtons(root);
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector(ROOT));
  });
})();
